export default function TextArea(props) {
  const {
    field,
    type,
    name,
    form,
    style,
    placeholder,
    helpText,
    noLabel = false,
    optional = false,
  } = props;

  return (
    <>
      <div className="form-group" style={style}>
        {!noLabel && (
          <label className="form-label" htmlFor={field}>
            {name}
          </label>
        )}
        <textarea
          className="form-control"
          id={field}
          name={field}
          type={type}
          onChange={form.handleChange}
          value={form.values[type]}
          placeholder={placeholder}
        />
        {(helpText || optional) && (
          <div className="row flex-nowrap">
            {helpText && (
              <div className="col">
                <small className="form-text text-muted">{helpText}</small>
              </div>
            )}
            {optional && (
              <div className="col-auto">
                <small className="form-text text-muted">(optional)</small>
              </div>
            )}
          </div>
        )}
        {form.errors.length > 0 && (
          <div className="form-error text-danger">
            <small>{form.errors[[field]]}</small>
          </div>
        )}
      </div>
    </>
  );
}
